import React from "react";
import { Route, Routes } from "react-router-dom";
import Registration from "./pages/Registration";
import Footer from "./components/footer";
import PublicCertificate from "./pages/PublicCertificate";
import CacheBuster from "react-cache-buster";
import appVersion from "../package.json";
import { CookieSetting } from "cookiesetting-component";

const App = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const { version } = appVersion;
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <>
        <Routes>
          <Route exact path="/" element={<Registration />} />
          <Route path="/:image_id" element={<PublicCertificate />} />
        </Routes>
        <Footer />
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
      </>
    </CacheBuster>
  );
};
export default App;
